import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

export default ({ value, id, data }) => {
    const { i18n } = useTranslation();
    let notTranslation = '';
    if (value && typeof value == 'object' && !value[i18n.language]) {
        for (let i in value) {
            if (!!value[i]) notTranslation = value[i] + ' (no translation)';
            break;
        }
    }
    const title =
        value && typeof value == 'object' ? (value[i18n.language] ? value[i18n.language] : notTranslation) : value;
    const isArchived = title === 0 && data?.numbers_student_archived > 0;
    const displayTitle = isArchived ? data.numbers_student_archived : title;

    return (
        <Link to={'/groups/' + id} name={displayTitle}>
            <Button
                variant="contained"
                color="inherit"
                style={{ width: '100px', textTransform: 'unset', border: isArchived ? '2px solid red' : 'none' }}
                className="single_group_btn"
            >
                {displayTitle}
            </Button>
        </Link>
    );
};
